"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTenantEnum = void 0;
const enums_1 = require("../enums");
function isValidTenantEnum(tenantValue) {
    return tenantValue in enums_1.TenantEnum;
}
exports.isValidTenantEnum = isValidTenantEnum;
//# sourceMappingURL=isValidTenantEnum.js.map